<div class="text-nowrap">
  <button
    *ngIf="file.type == 'file'"
    (click)="previewFile()"
    class="m-0 mr-1 btn btn-xs btn-info"
    ngbTooltip="Preview"
  >
    <i class="fa fa-eye"></i>
  </button>
  <button
    *ngIf="file.type == 'file'"
    (click)="downloadFile()"
    class="m-0 mr-1 btn btn-xs btn-info"
    ngbTooltip="Download"
  >
    <div
      *ngIf="downloading"
      class="spinner-border text-white mr-1"
      style="height: 9px; width: 9px"
      role="status"
    ></div>
    <i *ngIf="!downloading" class="fa fa-download"></i>
  </button>
  <button
    *ngIf="showEdit"
    (click)="editModal = true"
    class="m-0 mr-1 btn btn-xs btn-info"
    ngbTooltip="Edit"
  >
    <i class="fa fa-edit"></i>
  </button>
  <button
    (click)="deleteFile()"
    class="m-0 mr-1 btn btn-xs btn-primary"
    ngbTooltip="Delete"
  >
    <div
      *ngIf="deleting"
      class="spinner-border text-white mr-1"
      style="height: 9px; width: 9px"
      role="status"
    ></div>
    <i *ngIf="!deleting" class="fa fa-trash"></i>
  </button>
</div>

<!-- Preview Modal -->
<egi-modal
  *ngIf="previewUrl"
  [show]="previewUrl"
  size="xl"
  (close)="handleClose()"
>
  <div header>
    <h3>{{ file.name }}</h3>
  </div>
  <div style="height: 75vh">
    <div class="d-flex justify-content-center align-items-center overflow-auto">
      <iframe
        *ngIf="fileType == 'pdf'"
        [src]="previewUrl"
        style="width: 100%; height: 70vh; border: none"
      >
      </iframe>
      <img
        *ngIf="fileType == 'image'"
        [src]="previewUrl"
        style="width: auto; height: 100%; border: none"
      />
      <div *ngIf="fileType == 'other'">
        <h1>File preview not supported</h1>
      </div>
    </div>
  </div>
</egi-modal>

<!-- Edit Modal -->
<egi-modal
  *ngIf="editModal"
  [show]="editModal"
  size="lg"
  (close)="handleEditClose()"
>
  <div header>
    <h3>Edit File</h3>
  </div>
  <div
    class="d-flex flex-column justify-content-between"
    style="min-height: 50vh"
  >
    <div>
      <label> File Name </label>
      <input
        type="text"
        class="form-control form-control-sm mb-2"
        placeholder="File Name"
        [(ngModel)]="fileName"
      />
      <label>Move to</label>
      <egi-file-viewer
        [startingFolder]="{ uuid: file.parent }"
        [disabledFiles]="[file.uuid]"
        [limitToFolder]="limitToFolder"
        [showFiles]="false"
        [showButtons]="false"
        [showUpload]="false"
        (currentPathChange)="onCurrentPathChange($event)"
      ></egi-file-viewer>
    </div>

    <button
      class="btn btn-primary justify-self-end"
      (click)="onSave()"
      [disabled]="!fileName"
    >
      <div
        *ngIf="saving"
        class="spinner-border text-white mr-1"
        style="height: 1rem; width: 1rem"
        role="status"
      ></div>
      Save Changes
    </button>
  </div>
</egi-modal>
